import { createSvgIcon } from '@automata/mui-theme';
export const PrintLabelIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33 60V75H65V60H33ZM32 57C30.8954 57 30 57.8954 30 59V76C30 77.1046 30.8954 78 32 78H66C67.1046 78 68 77.1046 68 76V59C68 57.8954 67.1046 57 66 57H32Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33 21V33H65V21H33ZM32 18C30.8954 18 30 18.8954 30 20V34C30 35.1046 30.8954 36 32 36H66C67.1046 36 68 35.1046 68 34V20C68 18.8954 67.1046 18 66 18H32Z"
    />
    <path d="M76 45C76 47.2091 74.2091 49 72 49C69.7909 49 68 47.2091 68 45C68 42.7909 69.7909 41 72 41C74.2091 41 76 42.7909 76 45Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M61 64H37V66H61V64Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M51 69H37V71H51V69Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 66V36H76C78.7614 36 81 38.2386 81 41V66H68V69H82C83.1046 69 84 68.1046 84 67V41C84 36.5817 80.4183 33 76 33H14C12.8954 33 12 33.8954 12 35V67C12 68.1046 12.8954 69 14 69H30V66H15Z"
    />
  </svg>,
  'PrintLabelIcon'
);
